import useBbbAllPeriodMetric, {
  bbbAllPeriodMetricConfigs,
} from './useAllPeriodMetric'
import useIntradaySales, { intradaySalesConfigs } from './useIntradaySales'
import {
  bbbFoodAndPaperConfigs,
  bbbProfitAfterControllablesConfigs,
  useBbbFoodAndPaper,
  useBbbProfitAfterControllables,
} from './useMetricValues'
import useBbbTrendLocationDelivery, {
  bbbTrendLocationDeliveryConfigs,
} from './useTrendLocationDelivery'
import useBbbTrendLocationGroupDelivery, {
  bbbTrendLocationGroupDeliveryConfigs,
} from './useTrendLocationGroupDelivery'
import useBbbTrendLocationGroupPurchase, {
  bbbTrendLocationGroupPurchaseConfigs,
} from './useTrendLocationGroupPurchase'
import useBbbTrendLocationPurchase, {
  bbbTrendLocationPurchaseConfigs,
} from './useTrendLocationPurchase'
import useBbbTrendPeriodMetric, {
  bbbTrendPeriodMetricConfigs,
} from './useTrendPeriodMetric'
import useBbbWeeklySalesConfigs, {
  bbbWeeklySalesConfigs,
} from './useWeeklySales'

export const configs = {
  bbbWeeklySales: bbbWeeklySalesConfigs,
  bbbIntradaySales: intradaySalesConfigs,
  bbbFoodAndPaper: bbbFoodAndPaperConfigs,
  bbbProfitAfterControllables: bbbProfitAfterControllablesConfigs,
  bbbTrendPeriodMetric: bbbTrendPeriodMetricConfigs,
  bbbAllPeriodMetric: bbbAllPeriodMetricConfigs,
  bbbTrendLocationGroupPurchase: bbbTrendLocationGroupPurchaseConfigs,
  bbbTrendLocationPurchase: bbbTrendLocationPurchaseConfigs,
  bbbTrendLocationGroupDelivery: bbbTrendLocationGroupDeliveryConfigs,
  bbbTrendLocationDelivery: bbbTrendLocationDeliveryConfigs,
}

export const api = {
  bbbWeeklySales: useBbbWeeklySalesConfigs,
  bbbIntradaySales: useIntradaySales,
  bbbFoodAndPaper: useBbbFoodAndPaper,
  bbbProfitAfterControllables: useBbbProfitAfterControllables,
  bbbTrendPeriodMetric: useBbbTrendPeriodMetric,
  bbbAllPeriodMetric: useBbbAllPeriodMetric,
  bbbTrendLocationGroupPurchase: useBbbTrendLocationGroupPurchase,
  bbbTrendLocationPurchase: useBbbTrendLocationPurchase,
  bbbTrendLocationGroupDelivery: useBbbTrendLocationGroupDelivery,
  bbbTrendLocationDelivery: useBbbTrendLocationDelivery,
}
